import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@core/security/services/auth.service';
import { CookiesService } from '@utils/services/cookies.service';
import { Observable, tap } from 'rxjs';
import { expiredCodeSumax, InterceptStrategy } from './InterceptStrategy';

@Injectable({ providedIn: 'root' })
export class MaestrosSyncInterceptStrategy implements InterceptStrategy {
	endpoints = ['sumax-erp-backend-control-clientes', 'sumax-erp-backend-maestros-sync'];

	constructor(private cookiesService: CookiesService, private authService: AuthService) {}

	isRefreshToken = true;

	isIntercepted(req: HttpRequest<any>): boolean {
		return this.endpoints.some((path) => req.url.includes(path));
	}

	getHttpRequest(req: HttpRequest<any>): HttpRequest<any> {
		return req.clone({
			setHeaders: {
				Authorization: this.cookiesService.getBearerAuthorization('maestroSyncToken'),
			},
		});
	}

	isPosibleTokenExpired(error: HttpErrorResponse): boolean {
		return error.status === 403 && error.error && expiredCodeSumax.includes(error.error.codigo);
	}

	refreshToken(): Observable<Record<string, string>> {
		return this.authService
			.refreshToken()
			.pipe(
				tap((res) =>
					this.authService.updateTokens(res.idToken!, res.accessToken!, res.maestroSyncToken!)
				)
			) as unknown as Observable<Record<string, string>>;
	}
}
